import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import Speech from 'speak-tts'
import { s_lesson } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { ICON_PLAY_BUTTON_SMALL_PRIMARY } from '../../../modules/svg/svg'
import EmptyPage from '../../common/EmptyPage'

interface ExpressionPanelType {
  data: any
  onClickListen?: any //track
  paddingX?: number
  pbNone?: boolean
  isShort?: boolean
}
const ExpressionPanel: React.FC<ExpressionPanelType> = ({ data, onClickListen, pbNone = false, isShort = false }) => {
  const { t, isLocaleKO } = useTranslation()
  const [isMobile, setIsMobile] = useState(true)

  let speech: any = null
  const speak = (sample) => {
    let start_time
    ;(speech as any)
      ?.speak({
        text: sample.text,
        listeners: {
          onstart: () => {
            start_time = Date.now()
          },
          onend: () => {
            if (onClickListen) {
              const duration = Math.round((Date.now() - start_time) / 1000)
              console.log(duration)
              onClickListen(sample, duration)
            }
          },
        },
      })
      .then(() => {
        console.log('Success !')
      })
      .catch((e) => {
        console.error('An error occurred :', e)
      })
  }
  const handleListen = (e, sample) => {
    initSpeechTTS()
    speak(sample)
  }

  const handleSetVoice = () => {
    if ('speechSynthesis' in window) {
      const browserVoices = window.speechSynthesis.getVoices()
      const enVoices = browserVoices.filter((voice) => voice.lang === 'en-US')

      const PREFERRED_CHROME_VOICE = 'Google US English'
      const PREFERRED_APPLE_VOICE = 'Samantha'
      const preferredVoice =
        enVoices.find((v) => v.name === PREFERRED_CHROME_VOICE) ||
        enVoices.find((v) => v.name === PREFERRED_APPLE_VOICE) ||
        enVoices[0] ||
        browserVoices[0]

      speech.setVoice(preferredVoice.name)
    }
  }

  const initSpeechTTS = () => {
    speech = new Speech()
    speech.init({
      volume: 1,
      lang: 'en-US',
      rate: 1,
      pitch: 1,
      splitSentences: true,
      listeners: {
        onvoiceschanged: (voices) => {
          console.log('Event voiceschanged', voices)
        },
      },
    })
    handleSetVoice()
  }

  useEffect(() => {
    !isShort && initSpeechTTS()
  }, [isShort])

  useEffect(() => {
    if (window.screen.width < window.innerWidth) {
      setIsMobile(window.screen.width < 576)
    } else {
      setIsMobile(window.innerWidth < 576)
    }
  }, [])

  return (
    <div style={{ paddingBottom: pbNone ? '0px' : 'calc(15%)' }} className="no-scrollbar text-black sm:px-20 lg:px-0">
      <div className="">
        <>
          {data.expressions?.length > 0 ? (
            <>
              {data.expressions.map((item, i) => {
                if (isShort && i > 0) return //랜딩 컨텐츠에서 표현 하나만 보여줍니다.
                return (
                  <div
                    key={i}
                    className={classNames(
                      { 'h-[500px]': isMobile && isShort },
                      { 'overflow-hidden': isMobile && isShort },
                      { 'px-[20px]': isMobile && !isShort },
                      { 'border-b': item?.examples?.length > 0 },
                      'mb-[32px]'
                    )}
                  >
                    <div className="text-h1 mb-[14px] text-[20px] font-bold text-purple-500">{item.expression}</div>
                    <div className="mb-[16px]">
                      {isLocaleKO && <div className="text-h3 mb-[8px] text-[16px] font-medium">{item.meaning.ko}</div>}
                      <div className="mb-[16px] border-b pb-[16px]">{item.meaning.en}</div>
                      {item.tip && isLocaleKO && (
                        <div className="mb-[16px] border-b">
                          <div className="mb-[8px] font-medium">Ringle Tip</div>
                          <div className="mb-[16px]">{item.tip}</div>
                        </div>
                      )}
                    </div>
                    {item.examples && item.examples.length > 0 && (
                      <div>
                        <div>
                          {item.examples.map((example, j) => (
                            <div key={`example-${j}`}>
                              <div className="mb-[8px] flex items-end font-medium">
                                <div className="mr-[4px]">{t(s_lesson.example)}</div>
                                <div className="mr-[8px]">{j + 1}</div>
                                <button onClick={(e) => handleListen(e, example)}>
                                  <img src={ICON_PLAY_BUTTON_SMALL_PRIMARY} alt="play_button" />
                                </button>
                              </div>
                              <div key={j} className="mb-[16px]">
                                <p className="mb-8">{example.text}</p>
                                {isLocaleKO && <p className="mb-0">{example.meaning}</p>}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )
              })}
            </>
          ) : (
            <div className="px-[16px]">
              <EmptyPage title={t(s_lesson.does_not_provide_expressions)} />
            </div>
          )}
        </>
      </div>
    </div>
  )
}
export default ExpressionPanel
